import * as tslib_1 from "tslib";
import findFoldersCountsOnly from 'owa-mail-store/lib/services/findFoldersCountsOnly';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { lazySubscribe } from 'owa-notification';
import { onBulkActionHierarchyNotification } from 'owa-bulk-action-store';
import { trace } from 'owa-trace';
import { lazyOnCalendarNotification } from 'owa-upnext';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
function onHierarchyNotificationCallback(notification) {
    switch (notification.EventType) {
        case 'Reload':
        case 'QueryResultChanged':
            updateFoldersCounts();
            break;
        case 'RowAdded':
        case 'RowModified':
            var hierarchyNotification = notification;
            updateFolderCounts(hierarchyNotification.unreadCount, hierarchyNotification.itemCount, hierarchyNotification.folderId, false /* isDeltaChange */);
            onBulkActionHierarchyNotification(notification);
            if (hierarchyNotification.FolderType == 'CalendarFolder' &&
                isMailFeatureEnabled('tri-upNext')) {
                lazyOnCalendarNotification.import().then(function (onCalendarNotification) {
                    onCalendarNotification(notification);
                });
            }
            break;
        default:
            return;
    }
}
export default function subscribeToHierarchyNotification() {
    var subscription = {
        subscriptionId: 'HierarchyNotification',
        requiresExplicitSubscribe: true,
        subscriptionParameters: {
            NotificationType: 'HierarchyNotification',
        },
    };
    lazySubscribe.importAndExecute(subscription, onHierarchyNotificationCallback);
}
// update total and unread count for all folders
function updateFoldersCounts() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, findFoldersCountsOnly()];
                case 1:
                    response = _a.sent();
                    if (response.ResponseClass == 'Success') {
                        response.RootFolder.Folders.forEach(function (folder) {
                            updateFolderCounts(folder.UnreadCount, folder.TotalCount, folder.FolderId.Id, false /* isDeltaChange */);
                        });
                    }
                    else {
                        trace.warn('UpdateFolderCountsAction failed');
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=subscribeToHierarchyNotification.js.map